import { render, staticRenderFns } from "./KshMenuForm.vue?vue&type=template&id=0208bd36&scoped=true&"
import script from "./KshMenuForm.vue?vue&type=script&lang=js&"
export * from "./KshMenuForm.vue?vue&type=script&lang=js&"
import style0 from "./KshMenuForm.vue?vue&type=style&index=0&id=0208bd36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208bd36",
  null
  
)

export default component.exports